import { type ReactNode, useMemo } from 'react';
import { GraphQLTableAdapter, IcsDataTable } from '@ics-portal/ics-data-table';
import apolloClient from '@api/client';
import { GET_COMPONENTS_SEARCH_PAGED } from '@api/queries/components-paged';
import type { GetComponentsSearchPagedQuery } from '@gql/graphql';
import { COMPONENT_COLUMNS, type ComponentRow } from './columns';
import styles from './SearchComponentsTable.module.scss';

interface SearchComponentsTableProps {
    tableId: string;
    onSelectionChanged: (rows: ComponentRow[]) => void;
    headerSuffix?: ReactNode;
}

export function SearchComponentsTable(
    props: SearchComponentsTableProps,
): ReactNode {
    const { tableId, headerSuffix, onSelectionChanged } = props;

    const adapter = useMemo(
        () =>
            new GraphQLTableAdapter<
                GetComponentsSearchPagedQuery,
                ComponentRow
            >({
                client: apolloClient,
                query: GET_COMPONENTS_SEARCH_PAGED,
                extractConnection: (d) => d.components,
                searchFieldPaths: ['name', 'hasComponentVendorWith.name'],
                pageSize: 20,
            }),
        [],
    );

    return (
        <div className={styles.tableWrapper}>
            <IcsDataTable<ComponentRow>
                id={tableId}
                description="Component selection table"
                columns={COMPONENT_COLUMNS}
                adapter={adapter}
                selection="single"
                onSelectionChange={onSelectionChanged}
                searchPlaceholder="Search components"
                toolbarSlot={headerSuffix}
            />
        </div>
    );
}
